// extracted by mini-css-extract-plugin
module.exports = {"intermediariesTableInner":"IntermadiariesTable_intermediariesTableInner__NyD_X","intermediariesTable":"IntermadiariesTable_intermediariesTable__2ydlt"};